/**
 * Shared helpers for Report Center download-history tables.
 */

export function formatHistoryUserName(downloadedBy) {
  if (!downloadedBy || typeof downloadedBy !== 'object') return '—';
  const name = `${downloadedBy.firstName || ''} ${downloadedBy.lastName || ''}`.trim();
  return name || downloadedBy.email || '—';
}
